<template>
  <div style="height: 100vh;width: 100vw;">
    <!-- 页头 -->
    <nav-header2 style="position: absolute;z-index: 999;"></nav-header2>
    <div style="height: 60px;"></div>
    <div style="display: flex;height: calc(100% - 60px);width: 100%;">
      <!-- 侧边栏 -->
      <side-bar></side-bar>
      <div style="flex: 1;padding: 10px;background-color: #e4e7ed;display: flex;">
        <div class="content-box">
          <div class="table-list">
            <div class="title-box">
              <!-- 标题 -->
              <div class="title">系统设置</div>
              <!-- 按钮 -->
              <!-- <div class="btn-box"> -->
              <!-- </div> -->
            </div>
            <div class="system-content">
              <custom-tabs type="border-card" :tabsTitle="tabsTitle">
                <template v-slot:first>
                  <!-- <div class="default-config title">云平台</div> -->
                  <!-- <div class="config-file theme flex"> -->
                  <ul class="theme-config">
                    <li>
                      <p class="title">主题配置：</p>
                    </li>
                    <system-setting-item v-for="(item, index) in themeConfig" :key="index" set="theme"
                      :etitle="item.etitle" :slots="item.slots" :title="item.title" :content="item.content"
                      :inputc.sync="item.inputc" @handleSetContent="handleSetTheme(item)">
                      <template v-slot:theme>
                        <el-select v-model="themeConfig[11].inputc" clearable placeholder="请选择主题" size="medium">
                          <el-option v-for="item in themeOption" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </template>
                      <template v-slot:loginLogo>
                        <div class="uploadfile flex">
                          <el-upload class="upload-demo" action="#" :auto-upload="false" :show-file-list="false"
                            :on-change="($event) => handleChange($event, item)">
                            <el-button>上传图片</el-button>
                          </el-upload>
                          <el-tooltip class="item" effect="dark" :content="item.filename" placement="top">
                            <p class="ellipsis">{{ item.filename }}</p>
                          </el-tooltip>
                          <div class="preview-container" v-if="item.inputc">
                            <img :src="item.inputc" :alt="item.title + '预览'" title="点击预览图片" class="preview-img"
                              @click="previewImageClick(item)">
                            <i class="el-icon-close" @click="removePreview(item)"></i>
                          </div>
                        </div>
                        <el-progress :style="{ 'display': item.showprogress ? 'block' : 'none' }"
                          :percentage="item.percent"></el-progress>
                      </template>
                      <template v-slot:loginBackground>
                        <div class="uploadfile flex">
                          <el-upload class="upload-demo" action="#" :auto-upload="false" :show-file-list="false"
                            :on-change="($event) => handleChange($event, item)">
                            <el-button>上传图片</el-button>
                          </el-upload>
                          <el-tooltip class="item" effect="dark" :content="item.filename" placement="top">
                            <p class="ellipsis">{{ item.filename }}</p>
                          </el-tooltip>
                          <div class="preview-container" v-if="item.inputc">
                            <img :src="item.inputc" :alt="item.title + '预览'" title="点击预览图片" class="preview-img"
                              @click="previewImageClick(item)">
                            <i class="el-icon-close" @click="removePreview(item)"></i>
                          </div>
                        </div>
                        <el-progress :style="{ 'display': item.showprogress ? 'block' : 'none' }"
                          :percentage="item.percent"></el-progress>
                      </template>
                      <template v-slot:tagPageLogo>
                        <div class="uploadfile flex">
                          <el-upload class="upload-demo" action="#" :auto-upload="false" :show-file-list="false"
                            :on-change="($event) => handleChange($event, item)">
                            <el-button>上传图片</el-button>
                          </el-upload>
                          <el-tooltip class="item" effect="dark" :content="item.filename" placement="top">
                            <p class="ellipsis">{{ item.filename }}</p>
                          </el-tooltip>
                          <div class="preview-container" v-if="item.inputc">
                            <img :src="item.inputc" :alt="item.title + '预览'" title="点击预览图片" class="preview-img"
                              @click="previewImageClick(item)">
                            <i class="el-icon-close" @click="removePreview(item)"></i>
                          </div>
                        </div>
                        <el-progress :style="{ 'display': item.showprogress ? 'block' : 'none' }"
                          :percentage="item.percent"></el-progress>
                      </template>
                      <template v-slot:logo>
                        <div class="uploadfile flex">
                          <el-upload class="upload-demo" action="#" :auto-upload="false" :show-file-list="false"
                            :on-change="($event) => handleChange($event, item)">
                            <el-button>上传图片</el-button>
                          </el-upload>
                          <el-tooltip class="item" effect="dark" :content="item.filename" placement="top">
                            <p class="ellipsis">{{ item.filename }}</p>
                          </el-tooltip>
                          <div class="preview-container" v-if="item.inputc">
                            <img :src="item.inputc" :alt="item.title + '预览'" title="点击预览图片" class="preview-img"
                              @click="previewImageClick(item)">
                            <i class="el-icon-close" @click="removePreview(item)"></i>
                          </div>
                        </div>
                        <el-progress :style="{ 'display': item.showprogress ? 'block' : 'none' }"
                          :percentage="item.percent"></el-progress>
                      </template>
                    </system-setting-item>
                  </ul>
                  <!-- <ul class="theme-config emptybox"></ul> -->
                  <!-- </div> -->
                </template>
                <template v-slot:second>
                  <ul class="setting flex">
                    <li>
                      <p class="title">端口配置：</p>
                      <system-setting-item v-for="(item, index) in cloud" :key="index" set="cloud" :etitle="item.etitle"
                        :title="item.title" :content="item.content" :inputc.sync="item.inputc"
                        @handleSetContent="handleSetContent"></system-setting-item>
                    </li>
                  </ul>
                </template>
                <template v-slot:third>
                  <ul class="setting flex">
                    <li>
                      <p class="title">MQTT配置：</p>
                      <system-setting-item v-for="(item, index) in mqtt" :key="index" set="mqtt" :etitle="item.etitle"
                        :title="item.title" :content="item.content" :inputc.sync="item.inputc"
                        @handleSetContent="handleSetContent"></system-setting-item>
                    </li>
                  </ul>
                </template>
                <template v-slot:fourth>
                  <ul class="setting flex">
                    <li>
                      <p class="title">数据库配置：</p>
                      <system-setting-item v-for="(item, index) in db" :key="index" set="db" :etitle="item.etitle"
                        :title="item.title" :content="item.content" :inputc.sync="item.inputc"
                        @handleSetContent="handleSetContent"></system-setting-item>
                    </li>
                  </ul>
                </template>
                <template v-slot:fifth>
                  <ul class="setting flex">
                    <li>
                      <p class="title">短信配置：</p>
                      <system-setting-item v-for="(item, index) in textmessage" :key="index" set="db"
                        :etitle="item.etitle" :title="item.title" :content="item.content" :inputc.sync="item.inputc"
                        @handleSetContent="handleSetContent"></system-setting-item>
                    </li>
                  </ul>
                </template>
                <template v-slot:sixth>
                  <ul class="setting flex">
                    <li>
                      <p class="title">支付配置：</p>
                      <system-setting-item v-for="(item, index) in pay" :key="index" set="pay" :etitle="item.etitle"
                        :title="item.title" :content="item.content" :inputc.sync="item.inputc"
                        @handleSetContent="handleSetContent"></system-setting-item>
                    </li>
                    <!-- <li style="border: none;">
                    </li> -->
                  </ul>
                </template>
              </custom-tabs>
              <!-- <div class="title">配置文件</div>
              <div class="config-file">
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <preview-image-dialog ref="previewImageDialog" :preview-image="previewImage"
        :filename="filename"></preview-image-dialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import PreviewImageDialog from "@/components/previewImageDialog.vue";

export default {
  components: { PreviewImageDialog },
  data() {
    return {
      tabsTitle: [
        {
          label: "主题配置",
          name: "first",
        },
        {
          label: "端口配置",
          name: "second",
        },
        {
          label: "MQTT配置",
          name: "third",
        },
        {
          label: "数据库配置",
          name: "fourth",
        },
        {
          label: "短信配置",
          name: "fifth",
        },
        {
          label: "支付配置",
          name: "sixth",
        },
      ],
      cloud: [
        {
          title: '访问地址',
          etitle: 'host',
          inputc: null,
          content: '云平台访问公网地址'
        },
        {
          title: '访问端口',
          etitle: 'port',
          inputc: null,
          content: '云平台访问外网端口'
        },
        {
          title: 'API监听端口',
          etitle: 'listen',
          inputc: null,
          content: '云平台API监听端口'
        },
        {
          title: '日志存储位置',
          etitle: 'logger',
          inputc: null,
          content: '云平台日志存储位置'
        },
      ],
      mqtt: [
        {
          title: '访问地址',
          etitle: 'host',
          inputc: null,
          content: 'MQTT连接地址'
        },
        {
          title: '访问端口',
          etitle: 'port',
          inputc: null,
          content: 'MQTT连接端口'
        },
        {
          title: 'Client ID',
          etitle: 'id',
          inputc: null,
          content: 'MQTT连接Client ID'
        },
        {
          title: '用户名',
          etitle: 'name',
          inputc: null,
          content: 'MQTT连接用户名'
        },
        {
          title: '密码',
          etitle: 'password',
          inputc: null,
          content: 'MQTT连接密码'
        },
        {
          title: 'Keep Alive',
          etitle: 'keepalive',
          inputc: null,
          content: 'MQTT心跳时间，单位秒'
        },
      ],
      db: [
        {
          title: '访问地址',
          etitle: 'host',
          inputc: null,
          content: '数据库连接地址'
        },
        {
          title: '访问端口',
          etitle: 'port',
          inputc: null,
          content: '数据库连接端口'
        },
        {
          title: '数据库名称',
          etitle: 'database',
          inputc: null,
          content: '数据库名称'
        },
        {
          title: '用户名',
          etitle: 'user',
          inputc: null,
          content: '数据库连接用户名'
        },
        {
          title: '密码',
          etitle: 'password',
          inputc: null,
          content: '数据库连接密码'
        },
      ],
      textmessage: [
        {
          title: '用户名',
          etitle: 'account',
          inputc: null,
          content: '短信平台APIID'
        },
        {
          title: '密码',
          etitle: 'password',
          inputc: null,
          content: '短信平台APIKEY'
        },
      ],
      themeConfig: [
        {
          title: '登录页名称',
          etitle: 'loginName',
          inputc: null,
          content: '云平台登录页Heard名称',
        },
        {
          title: '登录页LOGO',
          etitle: 'loginLogo',
          inputc: null,
          content: '云平台登录页LOGO，仅支持PNG格式，尺寸20(高)*自适应(宽)',
          slots: "loginLogo",
          filename: '',
          percent: 0,
          showprogress: false,
          uploadLogo: '',
        },
        {
          title: '登录页背景图',
          etitle: 'loginBackground',
          inputc: null,
          content: '云平台登录页背景图，仅支持PNG、JPG格式，尺寸1920*1080',
          slots: "loginBackground",
          filename: '',
          percent: 0,
          showprogress: false,
          uploadLogo: '',
        },
        {
          title: '登录框名称',
          etitle: 'loginInputName',
          inputc: null,
          content: '登录框标签名称',
        },
        {
          title: '登录页关于我们链接',
          etitle: 'loginAbout',
          inputc: null,
          content: '登录页底部关于我们链接地址',
        },
        {
          title: '登录页官网链接',
          etitle: 'loginOfficial',
          inputc: null,
          content: '登录页底部官网链接',
        },
        {
          title: '登录页版权',
          etitle: 'loginCopyright',
          inputc: null,
          content: '登录页底部版权说明',
        },
        {
          title: '标签页名称',
          etitle: 'tagPageName',
          inputc: null,
          content: '网页标签页显示名称',
        },
        {
          title: '标签页LOGO',
          etitle: 'tagPageLogo',
          inputc: null,
          content: '网页标签页图标，仅支持ICON格式，尺寸48*48、32*32',
          slots: "tagPageLogo",
          filename: '',
          percent: 0,
          showprogress: false,
          uploadLogo: '',
        },
        {
          title: '云平台名称',
          etitle: 'name',
          inputc: null,
          content: '云平台Heard名称'
        },
        {
          title: '云平台LOGO',
          etitle: 'logo',
          inputc: null,
          content: '云平台LOGO，仅支持PNG格式，尺寸20(高)*自适应(宽)',
          slots: "logo",
          filename: '',
          percent: 0,
          showprogress: false,
          uploadLogo: '',
        },
        {
          title: '云平台主题',
          etitle: 'theme',
          inputc: null,
          content: '选择云平台默认主题',
          slots: "theme"
        },
      ],
      pay: [
        {
          title: '微信APPlD',
          etitle: 'wechatAppId',
          inputc: null,
          content: '微信商户平台APP ID'
        },
        {
          title: '微信API密钥',
          etitle: 'wechatKey',
          inputc: null,
          content: '微信商户平台APP V3密钥'
        },
        {
          title: '微信商户号',
          etitle: 'wechatMchId',
          inputc: null,
          content: '微信商户平台商户号'
        },
        {
          title: '微信API证书序列号',
          etitle: 'wechatSerialNo',
          inputc: null,
          content: '微信商户平台商户API证书序列号，证书文件(apiclient_key.pem)需放在配置文件目录下'
        },
      ],
      themeOption: [{
        value: 'default',
        label: '深蓝主题'
      }, {
        value: 'lightblue',
        label: '浅蓝主题'
      }, {
        value: 'darkgreen',
        label: '深绿主题'
      }, {
        value: 'lightgreen',
        label: '浅绿主题'
      }, {
        value: 'darkorange',
        label: '暗橙主题'
      }, {
        value: 'lightorange',
        label: '亮橙主题'
      }, {
        value: 'darkpurple',
        label: '深紫主题'
      }, {
        value: 'lightpurple',
        label: '浅紫主题'
      }],
      coludTheme: {},
      refreshKey: 0,
      copy: 1,
      systemsetconfig: 1,
      current: 1,
      size: 10,
      previewImage: '',
      filename: '',
    }
  },
  created() {
    this.getsystemsetconfig()
    this.getthemeConfig()
  },
  computed: {},
  methods: {
    // 配置文件
    async getsystemsetconfig() {
      let res = await this.$apiFun.systemsettingconfig()
      // console.log(res, 'dddddd');
      this.systemsetconfig = res.data
      this.cloud[0].inputc = this.systemsetconfig.cloud.host
      this.cloud[1].inputc = this.systemsetconfig.cloud.port
      this.cloud[2].inputc = this.systemsetconfig.cloud.listen
      this.cloud[3].inputc = this.systemsetconfig.cloud.logger
      this.mqtt[0].inputc = this.systemsetconfig.mqtt.host
      this.mqtt[1].inputc = this.systemsetconfig.mqtt.port
      this.mqtt[2].inputc = this.systemsetconfig.mqtt.id
      this.mqtt[3].inputc = this.systemsetconfig.mqtt.name
      this.mqtt[4].inputc = this.systemsetconfig.mqtt.password
      this.mqtt[5].inputc = this.systemsetconfig.mqtt.keepalive
      this.db[0].inputc = this.systemsetconfig.db.host
      this.db[1].inputc = this.systemsetconfig.db.port
      this.db[2].inputc = this.systemsetconfig.db.database
      this.db[3].inputc = this.systemsetconfig.db.user
      this.db[4].inputc = this.systemsetconfig.db.password
      this.textmessage[0].inputc = this.systemsetconfig.textmessage.account
      this.textmessage[1].inputc = this.systemsetconfig.textmessage.password
      this.pay[0].inputc = this.systemsetconfig.pay.wechatAppId
      this.pay[1].inputc = this.systemsetconfig.pay.wechatKey
      this.pay[2].inputc = this.systemsetconfig.pay.wechatMchId
      this.pay[3].inputc = this.systemsetconfig.pay.wechatSerialNo
    },
    // 主题配置
    async getthemeConfig() {
      let array = process.env.VUE_APP_PIc_URL.split(":")
      try {
        let res = await this.$apiFun.systemsettingtheme()
        this.coludTheme = res.data
        this.themeConfig[0].inputc = this.coludTheme.loginName
        this.themeConfig[1].inputc = array[0] + ":" + array[1] + (array.length > 2 ? ":" + array[2] : "") + "/" + this.coludTheme.loginLogo
        this.themeConfig[2].inputc = array[0] + ":" + array[1] + (array.length > 2 ? ":" + array[2] : "") + "/" + this.coludTheme.loginBackground
        this.themeConfig[3].inputc = this.coludTheme.loginInputName
        this.themeConfig[4].inputc = this.coludTheme.loginAbout
        this.themeConfig[5].inputc = this.coludTheme.loginOfficial
        this.themeConfig[6].inputc = this.coludTheme.loginCopyright
        this.themeConfig[7].inputc = this.coludTheme.tagPageName
        this.themeConfig[8].inputc = array[0] + ":" + array[1] + (array.length > 2 ? ":" + array[2] : "") + "/" + this.coludTheme.tagPageLogo
        this.themeConfig[9].inputc = this.coludTheme.name
        this.themeConfig[10].inputc = array[0] + ":" + array[1] + (array.length > 2 ? ":" + array[2] : "") + "/" + this.coludTheme.logo
        this.themeConfig[11].inputc = this.coludTheme.theme
        console.log(this.themeConfig, array, 'dddddd');
      } catch (error) {
        console.error('更新失败:', error);
      }
    },
    // 设置提交
    async handleSetContent(value) {
      // console.log(value);
      const res = await this.$apiFun.systemsettingupdate(value)
      if (res.code == 200) {
        this.$message({
          message: res.msg,
          type: 'success'
        });
        this.getsystemsetconfig()
      } else {
        this.$message({
          message: res.msg,
          type: 'error'
        });
      }
    },
    // 上传图片
    handleChange(file, item) {
      item.showprogress = true
      this.selectLogo = item.type
      // console.log(file, type, "datalllllll");
      const imgFile = file.raw;
      const isLt5M = file.size / 1024 / 1024 < 5;
      // console.log(isLt5M, "imgFile1111111");
      if (imgFile.type !== "image/png" && imgFile.type !== "image/jpeg" && item.type !== '标签页LOGO') {
        this.$message({
          message: "只支持上传png或者jpg格式文件",
          type: 'error'
        });
        item.showprogress = false
        return
      } else if (!file.name.endsWith('.ico') && item.type === '标签页LOGO') {
        this.$message({
          message: "只支持上传.ico格式文件",
          type: 'error'
        });
        item.showprogress = false
        return
      } else if (!isLt5M) {
        this.$message.error('上传图片大小不能超过5MB!');
        item.showprogress = false
        return
      } else if (imgFile.type === "image/png" || imgFile.type === "image/jpeg" || file.name.endsWith('.ico')) {
        item.uploadLogo = imgFile;
        item.filename = imgFile.name;
        // 读取文件并显示预览
        this.readFileAndPreview(imgFile, item);
        const interval = setInterval(() => {
          item.percent += Math.floor(Math.random() * 10) + 5
          if (item.percent >= 100) {
            item.percent = 100
            clearInterval(interval)
            setTimeout(() => {
              item.showprogress = false;
              item.item = 0;
            }, 500)
          }
        }, 300)
      }
    },
    // 默认配置提交
    async handleSetTheme(item) {
      let params = {}
      params = {
        key: item.etitle,
        value: item.inputc
      }
      if (item.etitle == 'logo' || item.etitle == "loginLogo" || item.etitle == "tagPageLogo" || item.etitle == "loginBackground") {
        const base64Data = await this.fileToBase64(item.uploadLogo);
        params = {
          key: item.etitle,
          fileData: base64Data,
          fileName: item.name
        }
      }
      // console.log(params, item, this.uploadLogo);
      const res = await this.$apiFun.systemsettingthemeupload(params)
      if (res.code == 200) {
        this.$message({
          message: res.msg,
          type: 'success'
        });
        this.getsystemsetconfig()
      } else {
        this.$message({
          message: res.msg,
          type: 'error'
        });
      }
    },
    // 读取文件并预览
    readFileAndPreview(file, item) {
      const reader = new FileReader();

      reader.onload = (e) => {
        item.inputc = e.target.result;
      };

      reader.onerror = (error) => {
        console.error('文件读取失败:', error);
        this.$message.error('文件读取失败');
      };

      reader.readAsDataURL(file);
    },
    // 图片转base64二进制
    fileToBase64(file) {
      if (file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
          reader.readAsDataURL(file);
        });
      }
    },
    // 移除图片
    removePreview(item) {
      this.$confirm('确定删除图片？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.previewImage = '';
        item.filename = '';
        item.percent = 0;
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },

    // 预览图片
    previewImageClick(item) {
      this.previewImage = item.inputc;
      this.filename = item.filename;
      this.$refs.previewImageDialog.openDialog();
    },
  }
}
</script>

<style scoped lang="less">
.content-box {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding: 0 16px 16px 16px;
  background-color: white;
  white-space: nowrap;
  width: 0px;
  overflow: auto;
}

.table-list {
  min-width: 1200px;
  height: calc(100vh - 60px);
}

.title-box {
  margin: 20px 0px 10px;
  height: 30px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
}

.title {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 10px;
}

// .config-file {
//     margin-top: 10px;
//     padding: 16px;
//     border: 1px solid #ebeef5;
// }

.setting {
  font-size: 12px;
  color: #333;
  flex-direction: row;
  column-gap: 20px;
  row-gap: 20px;
  justify-content: space-between;

  &:nth-child(2) {
    margin-top: 20px;
  }

  li {
    padding: 20px;
    border: 1px solid #ebeef5;
    // width: 48%;
    flex: 1;
    row-gap: 12px;
  }
}

// .theme {
//     margin-bottom: 16px;
//     column-gap: 20px;
//     row-gap: 20px;
// }

.theme-config {
  display: flex;
  flex-direction: column;
  flex: 1;
  font-size: 12px;
  border: 1px solid #ebeef5;
  padding: 16px;

  li {
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      white-space: nowrap;
    }

    :deep(.el-input) {
      width: 200px;

      .el-input__inner {
        font-size: 12px;
      }
    }

    :deep(.el-select) {
      font-size: 12px;
      width: 200px;

      .el-select-dropdown__empty {
        font-size: 12px;
      }
    }


    &:last-child {
      justify-content: end;

      .el-button {
        font-size: 12px;
        border: none;
        background-color: #1677ff;
      }
    }
  }

  :deep(.el-upload) {
    .el-button {
      border: none;
      font-size: 12px;
      padding: 0;
      color: #1677ff;

      &:hover {
        background-color: transparent;
        color: #1677ff;
      }

      &:focus {
        background-color: transparent;
        color: #1677ff;
      }
    }
  }
}

.uploadfile {
  align-items: center;

  p {
    margin: 0 !important;
    margin-left: 8px !important;
    cursor: pointer;
  }
}

.emptybox {
  border: none;
}

:deep(.el-progress) {
  .el-progress__text {
    font-size: 12px !important;
  }
}

.system-content {
  height: 100%;

  .el-tabs {
    height: 100%;

    .el-tabs__item:focus:active {
      background-color: transparent !important;
    }
  }
}

@media screen and (min-width: 1680px) {
  .titlebox {
    padding: 8px 0px;
    border: none;
  }

  .networkListtitle {
    background-color: #fafafb;
    border-top: 1px solid #e7e9f1;
    border-bottom: 1px solid #e7e9f1;
  }
}


.preview-container {
  display: flex;
  justify-content: space-between;
  margin-left: 20px;
  position: relative;
  background-color: #f5f5f5;

  .preview-img {
    max-width: 100px;
    max-height: 36px;
  }

  .el-icon-close {
    position: absolute;
    top: 0;
    right: 0;
    color: #fff;
  }
}
</style>